<section>
    <h1>Ej tillåtet (403)</h1>
    <p>Du har inte rättigheter att utföra det du vill göra. Du kan försöka <a [routerLink]="['/admin']">ta dig till startsidan</a> eller kontakta <a href="mailto:support@basetool.se">support@basetool.se</a> för att få hjälp.</p>
</section>